<template>
  <section class="action-section">
    <article class="container">
      <ContactsForm no-closable />
    </article>
  </section>
</template>

<script>
import ContactsForm from '../ContactsForm/ContactsForm.vue';

export default {
	name: 'SectionAction',
	components: { ContactsForm },
};
</script>

<style lang="scss" src="./SectionAction.scss" />
